import dayjs from 'dayjs';
import 'dayjs/locale/en';
import 'dayjs/locale/fr';
import 'dayjs/locale/nl';

import isoWeek from 'dayjs/plugin/isoWeek';
import timezone from 'dayjs/plugin/timezone';
import updateLocale from 'dayjs/plugin/updateLocale';
import weekday from 'dayjs/plugin/weekday';

import { createI18n } from 'vue-i18n';

import en from './locales/en.json';
import fr from './locales/fr.json';
import nl from './locales/nl.json';

import nxtStylesEn from '@nxtpeople/nxt-styles/dist/translations/en.json';
import nxtStylesFr from '@nxtpeople/nxt-styles/dist/translations/fr.json';
import nxtStylesNl from '@nxtpeople/nxt-styles/dist/translations/nl.json';

const userAgentLocale = window.navigator.language.substring(0, 2);
const savedLocale = window.localStorage.getItem('locale');
const locale = savedLocale || userAgentLocale || 'nl';

dayjs.extend(updateLocale);
dayjs.extend(weekday);
dayjs.extend(isoWeek);
dayjs.extend(timezone);

dayjs.locale(locale);
dayjs.updateLocale(locale, { weekStart: 1 });

export default createI18n({
   legacy: false,
   locale,
   fallbackLocale: 'nl',
   messages: {
      nl: { ...nl, ...nxtStylesNl },
      en: { ...en, ...nxtStylesEn },
      fr: { ...fr, ...nxtStylesFr },
   },
   globalInjection: true,
   fallbackWarn: false,
   allowComposition: true,
});
